import {
  React,
  Component,
  withRouter,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  InnovationDef,
  Criterias,
} from 'imports/ComponentsImports';

import {
  List,
  Divider,
} from 'material-ui';

import {
  PrimaryButton,
  SecondaryButton,
  AlertDialog,
  AlertDialogOneButton,
  LoadingDialog
} from 'imports/DesignImports';

const styles = {
  tutorialTitle: {
    marginLeft: '20px'
  },
  tutorialParagraph: {
    marginLeft: '1.5em'
  }
}

class ManagerSetupView extends Component {
  constructor(props){
    super(props);
    this.state = {
      token: this.props.cookies.get('token'),
      user: this.props.cookies.get('user'),
      innovation_def: "",
      choices: {},
      textInput: ""
    }
  }

  render() {
    return (
      <div style={styles.pageContainer}>
        <List>
          <div>
            <h1 style={styles.tutorialTitle}>Criterios Base</h1>
            <p style={styles.tutorialParagraph}>En esta sección deberás completar los criterios que servirán como base para medir la intensidad de innovación de tu empresa.</p>
            <Divider />
          </div>
          <InnovationDef send={false} done={this.props.done} update={this.updateInnovationDef}/>
          <Criterias send={false} done={this.props.done} history={this.props.history} update={this.updateCriterias} />
          {!this.props.done ? <div style={{display:'flex', justifyContent:'space-evenly'}}>
            <SecondaryButton label="Guardar Propuesta" onClick={() => {this.saveInnovationDef(() => this.sendFilters('save'))}} />
            <PrimaryButton label="Validación de comité"
              onClick={() => this.setState({
                alertDialog: true,
                alertTitle: '¡Atención!',
                alertMessage: '¿Estás seguro que quieres enviar los criterios? Estos deben estar validados por el comité de gerentes',
                confirm: () => this.saveInnovationDef(() => this.sendFilters('send')),
                cancel: () => this.setState({alertDialog: false})
            })} />
          </div>: null}
        </List>
        {this.state.loadingDialogOpen ? <LoadingDialog message="Estamos enviando los datos, espera un momento"/> : null}
        { this.state.alertDialogOneButton ?
          <AlertDialogOneButton
          title={this.state.alertTitle}
          message={this.state.alertMessage}
          acceptLabel='Aceptar'
          confirm={this.state.confirm}/> :
          null }
          { this.state.alertDialog ?
            <AlertDialog
            title={this.state.alertTitle}
            message={this.state.alertMessage}
            acceptLabel='Aceptar'
            cancelLabel='Cancelar'
            confirm={this.state.confirm}
            cancel={() => this.setState({alertDialog: false})}/> :
            null }
      </div>
    );
  }

  updateInnovationDef = (def) => {
    this.setState({innovation_def: def});
  }

  updateCriterias = (choices, textInput) => {
    this.setState({choices: choices, textInput: textInput});
  }

  saveCriterias = () => {
    this.saveInnovationDef(this.sendFilters);;
  }

  saveInnovationDef = (callback) => {
    if(this.state.innovation_def !== ""){
      this.setState({loadingDialogOpen: true})
      var innovation_def = {'innovation_def': this.state.innovation_def}
      var connection = axios.create({
        baseURL: routes.host,
        headers: {'Authorization': "Token "+ this.state.token}
      });
      connection.patch(routes.company(this.state.user.company_id), innovation_def)
        .then((response) => {
          callback();
        })
        .catch((error) => {
          this.alertDialogOpen('¡Error!', 'No se pudieron guardar los datos. Intenta nuevamente.');
          console.log(error);
        });
    } else {
      this.alertDialogOpen('¡Error!','Debes completar la definición de innovación antes de fijar los criterios.');
    }
  }

  alertDialogOpen = (title, message, confirm) => {
    this.setState({
      alertDialogOneButton: true,
      alertTitle: title,
      alertMessage: message,
      confirm: confirm,
      loadingDialogOpen: false
    });
  }

  checkFilterCompleteness = () => {
    let completeness = true
    Object.entries(this.state.choices).forEach(
      ([key, option]) => {
        if((option instanceof Array && option.length <= 0) || option === ''){
          completeness = false;
        }
      }
    );
    return completeness;
  }

  sendFilters = (decision) => {
    if(this.checkFilterCompleteness()){
      this.setState({loadingDialogOpen: true})
      var data = []
      Object.entries(this.state.choices).forEach(
        ([key, option]) => {
          if(option instanceof Array){
            option.forEach((opt) => data.push({filterId: key, optionName: opt}))
          }
          else {
            if(key === '31' && this.state.textInput !== ''){
              data.push({filterId: key, optionName: this.state.textInput})
            }
            else{
              data.push({filterId: key, optionName: option})
            }
          }
        }
      );
      var connection = axios.create({
        baseURL: routes.host,
        headers: {'Authorization': "Token "+ this.state.token}
      });
      var postFilters = decision === 'send' ? connection.post(routes.chooseFilters(this.state.user.company_id), data) : connection.post(routes.saveFilters(this.state.user.company_id), data)
      Promise.all([postFilters])
      .then((responses) => {
        var confirm = decision === 'send' ? () => this.props.history.push('home') : () => this.setState({alertDialogOneButton: false});
        this.alertDialogOpen('¡Muy bien!','Has guardado la propuesta con los criterios base para medir el i3 en tu empresa. Ahora debes organizar un comité de gerentes para validarla', confirm);
      })
      .catch((error) => {
        this.alertDialogOpen('¡Error!', 'No se pudieron guardar los datos. Intenta nuevamente.', () => this.setState({alertDialogOneButton: false}));
        console.log(error);
      });
    }
    else {
      this.alertDialogOpen('¡Error!','Debes llenar todos los campos antes de fijar los criterios', () => this.setState({alertDialogOneButton: false}));
    }

  }

}

export default withCookies(withRouter(ManagerSetupView));



// WEBPACK FOOTER //
// ./src/views/setup/ManagerSetupView.js